import type { PayloadContextType } from '@web-rendering/groundcontrol-core';
import { reportError } from '@web-rendering/groundcontrol-monitoring';

export const handleIframeError = (
  error: Error,
  context: {
    isRestrictedIframeCaller: boolean;
    payload: PayloadContextType;
    message: string;
    extraInfo?: Record<string, unknown>;
  }
) => {
  if (error instanceof Error) {
    reportError(error, {
      message: context.message,
      callerId: context.payload.network.callerId,
      networkId: context.payload.network.networkId,
      partnerId: context.payload.creative.partnerId,
      payload: context.payload,
      errorPayload: {
        isRestrictedIframeCaller: context.isRestrictedIframeCaller,
        ...context.extraInfo
      }
    });
  }
};
